import {SpaceTr, Tr, TrSpace} from "@/i18n/i18n";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {BuildingState, BuildingType, ClanBuildingInfo} from "@/store/clan/types";
import {Keys} from "@/constants/key";
import {AmountPanel} from "@/scenes.ui/amount-panel";
import TimeUtils from "@/utils/time-utils";
import {SquareButton} from "@/scenes.ui/square-button";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "../utils/c-u";
import Container = Phaser.GameObjects.Container;
import {ClanActionsPanel} from "@/scenes.ui.clan/clan-actions-panel";
import {ConfirmationPanel} from "@/scenes.ui/confirmation-panel";
import ClanStore from "@/store/clan";
import {FeedbackPanel} from "@/scenes.ui/feedback-panel";
import {SceneName} from "@/model/scene-name";
import {ClanHallPanel} from "@/scenes.ui.clan/clan-hall-panel";
import ClanScene from "@/scenes/clanScene";

export class ClanBuildingPanel extends Phaser.GameObjects.Container {

    public static HEIGHT = 650;

    private cont: Container | undefined;
    private cb!: ClanBuildingInfo;
    private startCallback!: () => unknown;
    private speedupCallback!: () => unknown;
    private completeCallback!: () => unknown;

    private clanScene: ClanScene;

    constructor(scene: ClanScene, cb: ClanBuildingInfo, startCallback: () => unknown, speedupCallback: () => unknown,
                completeCallback: () => unknown) {
        super(scene);

        this.clanScene = scene;
        this.scene = scene;
        this.width = CU.CANVAS_WIDTH;

        this.startCallback = startCallback;
        this.speedupCallback = speedupCallback;
        this.completeCallback = completeCallback;

        const back = SpriteUtils.addImage(this.scene, 0, 0, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_PANEL_BACK).setOrigin(0, 0);
        SpriteUtils.setDispSize(back, CU.CANVAS_WIDTH, ClanBuildingPanel.HEIGHT * CU.S);

        this.add(back);

        this.init(scene, cb);
    }

    public getClanBuildingInfo(): ClanBuildingInfo {
        return this.cb;
    }

    public init(scene: Phaser.Scene, cb: ClanBuildingInfo) {
        let self = this;
        this.cb = cb;
        if (this.cont) {
            this.cont.setVisible(false);
            this.cont.destroy();
        }
        this.cont = new Container(scene);

        let titleText = TextUtils.addTextAdvanced(scene, cb.name.toUpperCase(), 300, 30,
            '#ffd747', 14, 'normal', 480, 'center', 2, Fonts.BENGALY_NORMAL);

        let sep = SpriteUtils.addSprite(this.scene, 300, titleText.y / CU.S + 25, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR, 0.5, 0.4);

        let light = SpriteUtils.addSprite(this.scene, 300, sep.y / CU.S + 80, Keys.ATLAS_PROFILE, Keys.UI_ART_LIGHT, 2, 2);

        let buildingIcon = SpriteUtils.addSprite(this.scene, 300, light.y / CU.S, ClanBuildingPanel.getBuildingImageKey(cb));
        if (cb.levelCurr <= 0) {
            buildingIcon.setAlpha(0.3);
        }

        let nextY = buildingIcon.y / CU.S + 80 + (cb.buildingType == BuildingType.GEAR_FACTORY ? 20 : 0);
        if (cb.levelCurr > 0) {
            let bonusText = TextUtils.addTextAdvanced(scene, ClanBuildingPanel.getBonusText(cb), 300, nextY,
                '#ffd51f', 15, 'normal', 480, 'center', 2, Fonts.ARIAL_MT);

            let levelText = TextUtils.addTextAdvanced(scene, Tr('uroven').toUpperCase() + ': ' + cb.levelCurr + '/' + cb.levelMax, 300, bonusText.y / CU.S + 30,
                '#c4c3c3', 11, 'normal', 480, 'center', 2, Fonts.MYRIADPRO_REGULAR);
            nextY = levelText.y / CU.S + 40;
            this.cont.add([bonusText, levelText]);
        }

        let descText = TextUtils.addTextAdvanced(scene, ClanBuildingPanel.getBuildingDesc(cb), 300, nextY,
            '#f1f1f1', 12, 'normal', 480, 'center', 2, Fonts.BENGALY_NORMAL);

        let effectText = TextUtils.addTextAdvanced(scene, ClanBuildingPanel.getEffectDesc(cb), 300, descText.y / CU.S + 40,
            '#979797', 10, 'normal', 480, 'center', 2, Fonts.MYRIADPRO_REGULAR);

        let sep2 = SpriteUtils.addSprite(this.scene, 300, effectText.y / CU.S + 25, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR, 0.5, 0.3);

        nextY = sep2.y / CU.S;
        if (cb.buildingState === BuildingState.NORMAL) {

            let pricePanel: AmountPanel = new AmountPanel(scene, 160, nextY + 20,
                cb.levelCurr <= 0 ? Tr('stoimost.postroyki') : Tr('imp.cost') + ': ', cb.price);

            let timeText = TextUtils.addTextAdvanced(scene,
                Tr('vremja') + (cb.levelCurr <= 0 ? Tr('bld') : Tr('imp.g')) + ': ' + cb.updatingHours + Tr('hour.dot').toUpperCase(),
                300, pricePanel.y / CU.S + 40,
                '#d5d5d5', 12, 'normal', 480, 'center', 2, Fonts.BENGALY_NORMAL);

            this.cont.add([pricePanel, timeText]);
            nextY = timeText.y / CU.S;

            if (cb.canStartBuilding && cb.levelCurr < cb.levelMax) {
                let buildButton = new SquareButton(this.scene, 300, nextY + 95, 0, Keys.UI_ART_GREEN_BUTTON,
                    undefined, Keys.CL_HAMMER, cb.levelCurr <= 0 ? Tr('postroit') : Tr('imp'), false);
                buildButton.setCallback(() => {
                    self.startCallback();
                });
                this.cont.add(buildButton);
                nextY = buildButton.y / CU.S + 65;
            } else if (cb.levelCurr == cb.levelMax && cb.buildingType == BuildingType.HALL_OF_FAME) {
                let buildButton = new SquareButton(this.scene, 300, nextY + 95, 0, Keys.UI_ART_GREEN_BUTTON,
                    undefined, Keys.CLAN_GEAR, Tr('details'), false);
                buildButton.setCallback(() => {
                   this.clanScene.createClanHallPanel(cb.canStartBuilding);
                });
                this.cont.add(buildButton);
                nextY = buildButton.y / CU.S + 65;
            }

            //  СТОИМОСТЬ ПОСТРОЙКИ
            // ВРЕМЯ СТРОИТЕЛЬСТВА: 1Ч
            //      [ПОСТРОИТЬ]

            // СТОИМОСТЬ УЛУЧШЕНИЯ
            // ВРЕМЯ УЛУЧШЕНИЯ: 2Ч
            //      [УЛУЧШИТЬ]
        } else if (cb.buildingState === BuildingState.PROCESSING) {
            let remainSec: number = TimeUtils.remainSec(cb.releaseAt);

            if (remainSec > 0) {
                let improvingText = TextUtils.addTextAdvanced(scene, (cb.levelCurr <= 0 ? Tr('stroitsja') : Tr('imp.ing')),
                    300, nextY + 40,
                    '#ffd734', 13, 'bold', 480, 'center', 2, Fonts.MYRIADPRO_REGULAR);


                let timeText = TextUtils.addTextAdvanced(scene,
                    Tr('ostalos.vremeni') + ': ' + TimeUtils.getDurationTextSimple(remainSec),
                    300, improvingText.y / CU.S + 40,
                    '#d5d5d5', 12, 'normal', 480, 'center', 2, Fonts.BENGALY_NORMAL);

                this.cont.add([improvingText, timeText]);
                nextY = timeText.y / CU.S;

                if (cb.canStartBuilding) {
                    let speedupButton = new SquareButton(this.scene, 300, nextY + 95, 0, Keys.UI_ART_GREEN_BUTTON,
                        undefined, Keys.IC_100_MITHRIL, Tr('uskorit').toUpperCase(), false);
                    speedupButton.setCallback(() => {
                        self.speedupCallback();
                    });

                    let speedupPriceText = TextUtils.addText(this.scene,
                        String(cb.price.mithril), 300, speedupButton.y / CU.S + 34, '#ffffff', 25, 'bold', 200);

                    this.cont.add([speedupButton, speedupPriceText]);
                    nextY = speedupButton.y / CU.S + 65;
                }

                //    УЛУЧШАЕТСЯ
                //  ОСТАЛОСЬ: 59М.43С
                // СТОИМОСТЬ УСКОРЕНИЯ
                //     [УСКОРИТЬ]
            } else {

                let readyText = TextUtils.addTextAdvanced(scene, Tr('postroyka.gotova'),
                    300, nextY + 40,
                    '#55ff2b', 12, 'bold', 480, 'center', 2, Fonts.ARIAL_MT);
                this.cont.add(readyText);

                nextY = readyText.y / CU.S;

                if (cb.canCompleteBuilding) {
                    let completeButton = new SquareButton(this.scene, 300, nextY + 95, 0, Keys.UI_ART_GREEN_BUTTON,
                        Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, Tr('zavershit'), false);
                    completeButton.setCallback(() => {
                        self.completeCallback();
                    });
                    this.cont.add(completeButton);
                    nextY = completeButton.y / CU.S + 65;
                }

                // ПОСТРОЙКА ГОТОВА
                //    [ЗАВЕРШИТЬ]
            }
        }

        let sep3 = SpriteUtils.addSprite(this.scene, 300, nextY + 40, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR);

        this.height = sep3.y / CU.S;

        this.cont.add([titleText, sep, light, sep, buildingIcon, effectText, descText, sep2, sep3]);
        this.add(this.cont);
    }

    private static getBonusText(cb: ClanBuildingInfo): string {
        switch (cb.buildingType) {
            case BuildingType.EXPERIENCE:
                return Tr('opit.plus') + (cb.bonus - 100) + '%';
            case BuildingType.CLAN_SHIELD:
                return Tr('zaschita.klana') + cb.bonus + '%';
            case BuildingType.SNOW_WORLD:
                return TrSpace('km.snow') + (cb.bonus / 1000) + SpaceTr('met');
            case BuildingType.GEAR_FACTORY:
                return Tr('factory.gift.value.plus') + (cb.bonus ) + '%';
            case BuildingType.HALL_OF_FAME:
                return "";
        }
        return '';
    }

    private static getBuildingImageKey(cb: ClanBuildingInfo): string {
        switch (cb.buildingType) {
            case BuildingType.EXPERIENCE:
                return Keys.CL_ACADEMY;
            case BuildingType.CLAN_SHIELD:
                return Keys.CL_GUILD;
            case BuildingType.SNOW_WORLD:
                return Keys.CL_LAB;
            case BuildingType.GEAR_FACTORY:
                return Keys.CL_FACTORY;
            case BuildingType.HALL_OF_FAME:
                return Keys.CL_HALL;
        }
        return '';
    }

    private static getBuildingDesc(cb: ClanBuildingInfo): string {
        switch (cb.buildingType) {
            case BuildingType.EXPERIENCE:
                return Tr('uvelichivaet.opit.poluchaemiy.za.boy.vsem.uchastnikov.klana');
            case BuildingType.CLAN_SHIELD:
                return Tr('zaschischaet.soklanovtsev.v.bojah.otrazhaja.chast.udarov');
            case BuildingType.SNOW_WORLD:
                return Tr('b.snow');
            case BuildingType.GEAR_FACTORY:
                return Tr('factory.info');
            case BuildingType.HALL_OF_FAME:
                return Tr('hall.info');
        }
        return '';
    }

    private static getEffectDesc(cb: ClanBuildingInfo): string {
        switch (cb.buildingType) {
            case BuildingType.EXPERIENCE:
                return '+' + cb.bonusDelta + Tr('pct.for.lev');
            case BuildingType.CLAN_SHIELD:
                return '+' + cb.bonusDelta + Tr('rep.for.lev');
            case BuildingType.SNOW_WORLD:
                return '+' + (cb.bonusDelta / 1000) + SpaceTr('m.p.lev');
            case BuildingType.GEAR_FACTORY:
                return '+' + cb.bonusDelta + Tr('factory.for.lev')
            case BuildingType.HALL_OF_FAME:
                return "";
        }
        return '';
    }
}
